export const PAGE_SIZE = 10;
export const BUTTON_ICON_SIZE = 16;
export const SEARCH_ICON_SIZE = 18;
export const ROW_ICON_SIZE = 24;
/** The icon beside a chart panel's title, as the Checklists panel draws it. */
export const SECTION_ICON_SIZE = 32;
export const PRIORITY_DOT_SIZE = 7;
export const VISIBILITY_INFO_ICON_SIZE = 16;
/** Wraps the visibility message onto two lines, as the app's other explanatory tooltips do. */
export const VISIBILITY_TOOLTIP_MAX_WIDTH = 260;
/** Long enough for the pointer to cross from the icon onto the tooltip before it closes. */
export const VISIBILITY_TOOLTIP_CLOSE_DELAY = 200;

/** One row of the info box's flag list. The empty row uses it too, so both read as one list. */
export const CLIENT_FLAG_ROW_PROPS = {
  px: "sm",
  py: "xs",
  gap: "sm",
  bg: "gray.0",
  wrap: "nowrap",
  justify: "space-between",
} as const;
export const SEARCH_INPUT_WIDTH = 360;
/** Matches the other icons in the client list toolbar. */
export const FILTER_BUTTON_ICON_SIZE = 16;

/** Wide enough for the longest library flag name beside its priority badge. */
export const POPOVER_WIDTH = 300;
/** Design calls for 500px; 512 is the width most drawers in the app already use. */
export const DRAWER_WIDTH = 512;
export const DESCRIPTION_INPUT_ROWS = 3;
/** The drawer header height most drawers in the app use. */
export const DRAWER_HEADER_HEIGHT = 64;

/** Success toasts clear themselves; errors stay until dismissed. Matches the flag library. */
export const SUCCESS_TOAST_DURATION = 3000;
export const TABLE_MIN_WIDTH = 1096;

/** Holds the table's place while the library loads, so the controls above it do not jump. */
export const TABLE_LOADING_HEIGHT = 240;

/** Holds the top of the client flags drawer while its chart and library reads land. */
export const DRAWER_LOADING_HEIGHT = 128;

/** Stands in for an unset cell, matching the "--" the client list table already uses. */
export const EMPTY_CELL = "--";

export const TABLE_COLUMN_WIDTHS = {
  flag: "47%",
  category: "14%",
  priority: "12%",
  chartCount: "11%",
  actions: "16%",
} as const;

/** Six columns, the last of them free text, need at least this width before the table scrolls. */
export const ARCHIVE_TABLE_MIN_WIDTH = 900;

export const ARCHIVE_COLUMN_WIDTHS = {
  name: "24%",
  priority: "12%",
  category: "14%",
  date: "14%",
  provider: "16%",
  reason: "20%",
} as const;
